import React, { useState } from 'react';

export default function Image({ image, setTouched, deleteImage }) {
  const [isHovered, setIsHovered] = useState(false);

  const src = image instanceof File ? URL.createObjectURL(image) : image?.url;

  return (
    <li
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative w-32 h-32 bg-gray-200">
        {isHovered && (
          <button
            type="button"
            className="absolute -right-4 -top-4 block rounded-full bg-slate-100 dark:bg-slate-700 text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300"
            onClick={(event) => {
              event.stopPropagation();
              deleteImage();
              setTouched();
            }}
          >
            <span className="sr-only">Delete</span>
            <svg width="32" height="32" viewBox="0 0 32 32">
              <path
                className="fill-current"
                d="M15.95 14.536l4.242-4.243a1 1 0 111.415 1.414l-4.243 4.243 4.243 4.242a1 1 0 11-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 01-1.414-1.415l4.243-4.242-4.243-4.243a1 1 0 011.414-1.414l4.243 4.243z"
              />
            </svg>
          </button>
        )}
        <img
          src={src}
          alt={image.name}
          className="w-full h-full object-contain"
        />
      </div>
    </li>
  );
}
